import { createContext, useContext as useReactContext } from 'react'

import { HeaderContextType } from '../Header.types'

export const useHeaderContext = (): HeaderContextType => {
  const context = useReactContext(HeaderContext)
  if (context === undefined) {
    return {} as HeaderContextType
    // throw new Error('useAuth must be used within an AuthenticatedProvider')
  }
  return context
}

const HeaderContext = createContext<HeaderContextType>({
  banner: null,
  isOpen: false,
  setIsOpen: () => {},
  compressed: false,
  menu: [],
  isMobile: undefined,
  translationsItems: undefined,
})

export default HeaderContext
